import * as React from 'react'
import type {SVGProps} from 'react'
const SvgQuiz = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={22}
        height={22}
        fill="currentColor"
        viewBox="0 0 22 22"
        {...props}
    >
        <path d="M3.136 0A3.14 3.14 0 0 0 0 3.143v15.714A3.14 3.14 0 0 0 3.136 22h15.678c1.729 0 3.135-1.41 3.135-3.143V3.143A3.14 3.14 0 0 0 18.814 0zM6.75 6.546a2.75 2.75 0 0 1 2.587-1.832h2.857c1.71 0 3.091 1.39 3.091 3.099a3.11 3.11 0 0 1-1.553 2.691l-1.583.909a1.18 1.18 0 0 1-1.175 1.158 1.174 1.174 0 0 1-1.176-1.178v-.663c0-.422.225-.81.593-1.022l2.17-1.247a.743.743 0 0 0-.367-1.385H9.337a.39.39 0 0 0-.367.26l-.02.06a1.175 1.175 0 0 1-1.5.717 1.183 1.183 0 0 1-.714-1.503l.02-.06zm2.656 9.168a1.573 1.573 0 0 1 1.568-1.571 1.566 1.566 0 0 1 1.567 1.571 1.573 1.573 0 0 1-1.567 1.572 1.566 1.566 0 0 1-1.568-1.572" />
    </svg>
)
export default SvgQuiz
